import React, { Component } from 'react';
import { ThemeColors } from '../../theme';
import PropTypes from 'prop-types';
import { Button, TextField } from '../../components';
import FineUploaderTraditional from 'fine-uploader-wrappers';
import FileInput from 'react-fine-uploader/file-input';
import FaceIcon from '@material-ui/icons/Face';
import CheckIcon from '@material-ui/icons/CheckCircleOutlined';
import Config from '../../../run-config';
import Avatar from '@material-ui/core/Avatar';


class Profile extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 'profile',
      newPassword: '',
      newPassword2: '',
      oldPassword: '',
      errorMessage: '',
    };
  }

  componentWillMount() {
    if (this.props.user) {
      this.setState({ ...this.props.user });
    }
  }

  componentWillReceiveProps({ user, errorMessage }) {
    if (user && user !== this.props.user) {
      this.setState({ ...user });
    }

    if (errorMessage) {
      this.setState({ errorMessage });
    }
  }

  checkContainsLowerCase = () => {
    const regExp = /(?=.*[a-z])/;
    return this.state.newPassword.match(regExp);
  }

  checkContainsUpperCase = () => {
    const regExp = /(?=.*[A-Z])/;
    return this.state.newPassword.match(regExp);
  }

  checkContainsNumberOfSpecialChar = () => {
    const regExp = /(?=.*[-+_!@#$%^&*.,?])|(?=.*\d)/;
    return this.state.newPassword.match(regExp);
  }

  canSave = () => this.check8CharsLong() && this.checkContainsLowerCase() && this.checkContainsNumberOfSpecialChar() &&
    this.checkContainsUpperCase() && this.state.newPassword === this.state.newPassword2 &&
    this.state.currentPassword !== ''


  onChangePassword = () => {
    const changePasswordDto = {
      oldPassword: this.state.oldPassword,
      newPassword: this.state.newPassword,
    };

    this.props.changePassword(changePasswordDto);
  }

  check8CharsLong = () => this.state.newPassword.length >= 8

  renderAvatar() {
    const saveIsDisabled = this.props.config.editablePersonalDetails &&
    this.props.config.editablePersonalDetails === 'false';

    const uploader = new FineUploaderTraditional({
      options: {
        request: {
          endpoint: `${Config.apiHost}/adminApi/user/file`,
        },
        callbacks: {
          onComplete: (id, name, response) => {
            this.setState({ avatarUrl: response.displayUrl });
          },
        },
      },
    });

    return (
      <FileInput accept="image/*" uploader={uploader} disabled={saveIsDisabled}>
        {this.renderProfilePicture()}
      </FileInput>
    );
  }

  renderProfilePicture() {
    const avatarStyle = {
      marginRight: 10,
      marginBottom: 20,
    };

    return this.state.avatarUrl
      ? (<Avatar style={avatarStyle} src={this.state.avatarUrl} size={40} />)
      : (<Avatar style={avatarStyle}><FaceIcon /></Avatar>);
  }

  renderProfileForm() {
    const margin = { marginTop: 10 };
    return (
      <div>
        <h1 style={{ color: ThemeColors.accent2Color }}>Bearbeite deine Benutzerinformation</h1>
        <div className="col-md-12">{this.renderAvatar()}</div>

        <div className="col-md-6">
          <TextField
            formControlStyle={margin}
            label="Vorname"
            value={this.state.firstName}
            onChange={e => this.setState({ firstName: e.target.value })}
          />
          <TextField
            formControlStyle={margin}
            label="E-Mail"
            disabled
            value={this.state.email}
            onChange={e => this.setState({ email: e.target.value })}
          />
          <TextField
            formControlStyle={margin}
            label="Adresse"
            value={this.state.address}
            onChange={e => this.setState({ address: e.target.value })}
          />
          <TextField
            formControlStyle={margin}
            label="Ort"
            value={this.state.city}
            onChange={e => this.setState({ city: e.target.value })}
          />
        </div>

        <div className="col-md-6">
          <TextField
            formControlStyle={margin}
            label="Nachname"
            value={this.state.lastName}
            onChange={e => this.setState({ lastName: e.target.value })}
          />

          <TextField
            formControlStyle={margin}
            label="Position"
            value={this.state.position}
            onChange={e => this.setState({ position: e.target.value })}
          />

          <TextField
            formControlStyle={margin}
            label="PLZ"
            value={this.state.zip}
            onChange={e => this.setState({ zip: e.target.value })}
          />

          <TextField
            formControlStyle={margin}
            label="Land"
            value={this.state.country}
            onChange={e => this.setState({ country: e.target.value })}
          />
        </div>
      </div>
    );
  }

  renderPasswordChecks() {
    const checkContainer = {
      display: 'flex',
      marginTop: 5,
      // justifyContent: 'space-between'
    };

    return (
      <div className="col-sm-12 col-md-8 col-lg-8" style={{ margin: '10px 0' }}>
        <div style={{ ...checkContainer, ...{ color: this.check8CharsLong() ? ThemeColors.accent2Color : 'black' } }} >
          <CheckIcon color={this.check8CharsLong() ? ThemeColors.accent2Color : 'black'} />
          <span>Mindestens 8 Zeichen lang</span>
        </div>

        <div style={{ ...checkContainer, ...{ color: this.checkContainsLowerCase() ? ThemeColors.accent2Color : 'black' } }} >
          <CheckIcon color={this.checkContainsLowerCase() ? ThemeColors.accent2Color : 'black'} />
          <span>Mindestens ein Kleinbuchstabe</span>
        </div>

        <div style={{ ...checkContainer, ...{ color: this.checkContainsUpperCase() ? ThemeColors.accent2Color : 'black' } }} >
          <CheckIcon color={this.checkContainsUpperCase() ? ThemeColors.accent2Color : 'black'} />
          <span>Mindestens ein Großbuchstabe</span>
        </div>

        <div style={{ ...checkContainer, ...{ color: this.checkContainsNumberOfSpecialChar() ? ThemeColors.accent2Color : 'black' } }} >
          <CheckIcon color={this.checkContainsNumberOfSpecialChar() ? ThemeColors.accent2Color : 'black'} />
          <span>Eine Zahl, ein Sonderzeichen oder Leerzeichen</span>
        </div>
      </div>
    );
  }

  renderSideNavigation() {
    const sideButtonStyle = {
      textAlign: 'left',
      display: 'block',
      minWidth: 200,
      marginBottom: 5,
      height: 50,
    };

    const labelStyleProfileData = this.state.selectedTab === 'profile'
      ? {
        textAlign: 'left', color: ThemeColors.accent2Color,
      }
      : {
        textAlign: 'left', color: '#222',
      };

    const labelStyleChangePassword = this.state.selectedTab === 'changePassword'
      ? {
        textAlign: 'left', color: ThemeColors.accent2Color,
      }
      : {
        textAlign: 'left', color: '#222',
      };

    const changePasswordButton = !Config.forbidToChangePassword
       ? (<Button
         onClick={() => this.setState({ selectedTab: 'changePassword' })}
         label="Passwort ändern"
         style={sideButtonStyle}
         secondary
         labelStyle={labelStyleChangePassword}
       />)
     : null;

    return (
      <div style={{ marginTop: 20 }}>
        <Button
          onClick={() => this.setState({ selectedTab: 'profile' })}
          label="Profildaten"
          style={sideButtonStyle}
          secondary
          labelStyle={labelStyleProfileData}
        />
        {changePasswordButton}

      </div>
    );
  }

  renderChangePasswordForm() {
    const margin = { marginTop: 10 };

    return (
      <div className="col-md-12">
        <h1 style={{ color: ThemeColors.accent2Color }}>Ändere dein Passwort</h1>
        <span style={{ color: 'red' }}>{this.state.errorMessage}</span>
        <div className="col-md-6">
          <TextField
            label="Aktuelles Passwort bestätigen"
            value={this.state.oldPassword}
            type="password"
            formControlStyle={margin}
            onChange={e => this.setState({ oldPassword: e.target.value })}
          />
          <TextField
            label="Neues Passwort"
            value={this.state.newPassword}
            type="password"
            formControlStyle={margin}
            onChange={e => this.setState({ newPassword: e.target.value })}
          />
          <TextField
            label="Neues Passwort wiederholen"
            type="password"
            value={this.state.newPassword2}
            formControlStyle={margin}
            onChange={e => this.setState({ newPassword2: e.target.value })}
          />
        </div>
        {this.renderPasswordChecks()}
      </div>
    );
  }

  renderEditUserInfo() {
    const buttonStyle = {
      fontSize: '14px',
      height: 60,
      marginTop: 10,
    };

    const saveIsDisabled = this.props.config.editablePersonalDetails &&
    this.props.config.editablePersonalDetails === 'false';

    return (
      <div className="col-sm-12 col-md-8 col-lg-8" style={{ marginBottom: '40px', overflow: 'hidden' }}>
        {this.renderProfileForm()}
        <div style={{ marginTop: '20px', marginLeft: 10, textAlign: 'left' }} className="doNotPrint">
          <Button
            variant="contained"
            color="primary"
            className={'pm-course-button'}
            onClick={() => this.props.updateUserData(this.state)}
            label="Speichern"
            disabled={saveIsDisabled}
            style={buttonStyle}
            backgroundColor={ThemeColors.positiveColor}
            buttonStyle={{ height: '60px' }}
            labelStyle={{ color: '#fff', fontSize: 12 }}
          />
        </div>
      </div>
    );
  }

  renderChangePassword() {
    const buttonStyle = {
      fontSize: '14px',
      height: 60,
      marginTop: 10,
    };

    return (
      <div className="col-sm-12 col-md-8 col-lg-8" style={{ marginBottom: '40px', overflow: 'hidden' }}>
        {this.renderChangePasswordForm()}
        <div style={{ marginTop: '20px', marginLeft: 10, textAlign: 'left' }} className="doNotPrint">
          <Button
            variant="contained"
            color="primary"
            className={'pm-course-button'}
            onClick={this.onChangePassword}
            label="Passwort ändern"
            disabled={!this.canSave()}
            style={buttonStyle}
            backgroundColor={ThemeColors.positiveColor}
            buttonStyle={{ height: '60px' }}
            labelStyle={{ color: '#fff', fontSize: 12 }}
          />
        </div>
      </div>
    );
  }


  render() {
    return (
      <div style={{ marginBottom: '40px', overflow: 'hidden' }}>
        {this.state.selectedTab === 'profile'
          ? this.renderEditUserInfo()
          : this.renderChangePassword()}

        <div className="col-sm-12 col-md-4 col-lg-4 doNotPrint">
          {this.renderSideNavigation()}
        </div>
      </div>

    );
  }
}

Profile.propTypes = {
  config: PropTypes.object,
};

Profile.defaultProps = {
  config: {},
};

export default Profile;



// WEBPACK FOOTER //
// ./src/app/main/profile/profile.js